let checkoutPromise;

function loadCheckout() {
  if (window.Razorpay) return Promise.resolve();
  if (checkoutPromise) return checkoutPromise;
  checkoutPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => {
      if (window.Razorpay) {
        resolve();
      } else {
        checkoutPromise = undefined;
        reject(new Error("Secure checkout loaded incorrectly. Please try again."));
      }
    };
    script.onerror = () => {
      checkoutPromise = undefined;
      reject(new Error("Could not load secure checkout."));
    };
    document.head.appendChild(script);
  });
  return checkoutPromise;
}

export async function openRazorpayCheckout(order) {
  await loadCheckout();
  return new Promise((resolve, reject) => {
    let completed = false;
    const checkout = new window.Razorpay({
      key: order.keyId,
      order_id: order.orderId,
      amount: order.amountMinor,
      currency: order.currency,
      name: order.name,
      description: order.description,
      prefill: order.prefill,
      theme: { color: "#F59E0B" },
      retry: { enabled: true },
      handler: (response) => {
        completed = true;
        resolve(response);
      },
      modal: {
        confirm_close: true,
        ondismiss: () => {
          if (!completed) reject(new Error("Checkout was closed before payment."));
        },
      },
    });
    checkout.on("payment.failed", (response) => {
      completed = true;
      reject(new Error(response?.error?.description || "Payment failed."));
    });
    try {
      checkout.open();
    } catch (error) {
      completed = true;
      reject(new Error(error?.message || "Could not open secure checkout."));
    }
  });
}
